<template>
  <div class="step3A__highlight-card">
    <table class="wsaTable light-scrollbar">
      <tr class="table-heading-wsa3A">
        <td colspan="10">Wall surface area</td>
      </tr>
      <tr>
        <td class="grey-row-3A" style="width:180px">Orientation</td>
        <template v-for="(orient, orientationIndex) in step3A.wallSurfaceAreaArrObj">
          <td v-if="orient.orientationSurfaceArea !== 0 && orient.orientationSurfaceArea !== ''" class="grey-row-3A">{{ orient.wallOrientation }}</td>
        </template>
      </tr>
      <tr>
        <td class="grey-row-3A" style="width:180px">Wall surface area <span class="highlight_units">(%)</span></td>
        <template v-for="(orient, orientationIndex) in step3A.wallSurfaceAreaArrObj">
          <td v-if="orient.orientationSurfaceArea !== 0 && orient.orientationSurfaceArea !== ''" class="input-row-3A" style="width:80px">{{ orient.orientationSurfaceArea || 0 }}</td>
        </template>
      </tr>

      <tr>
        <td class="grey-row-3A" style="width:180px">Wall surface area <span class="highlight_units"> (sq.M)</span></td>
        <template v-for="(orient, orientationIndex) in step3A.wallSurfaceAreaArrObj">
          <td v-if="orient.orientationSurfaceArea !== 0 && orient.orientationSurfaceArea !== ''" style="width:80px">{{ orient.calcWallArea }}</td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step2: {
      get: function() {
        return this.$store.state.schema.inputs.step2;
      },
      set: function(step2) {
        this.$store.dispatch('setStep2', step2);
      },
    },
    step3A: {
      get: function() {
        return this.$store.state.schema.inputs.step3A;
      },
      set: function(step3A) {
        this.$store.dispatch('setStep3A', step3A);
      },
    },
  },
};
</script>

<style lang="scss">
.step3A__highlight-card {
  background-color: #fff;
  // margin: 24px 0px;
  // padding: 38px;
  .highlight-header {
    background-color: #5a6978;

    padding: 8px 24px;
    color: #fff;
    font-size: 20px;
  }
}

.hightlight__content-container {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  // justify-content: space-evenly;
}

.highlight__wall--surface {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #868585;
  background-color: #c8f0e0;
  color: #2cb17c;
}
.highlight-table3A-col {
  border-right: 1px solid #a4abb3;

  .col-width {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 82px;
  }

  .heading,
  .input,
  .value {
    text-align: center;
    border-bottom: 1px solid #a4abb3;
    width: 100%;
  }
  .heading {
    background-color: #dedede;
  }
  .input {
    background-color: #c4def5;
  }
}
.highlight-table3A-label-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #a4abb3;
  width: 220px;
  .label {
    text-align: center;
    border-bottom: 1px solid #a4abb3;
    width: 100%;
    // font-size: 13px;
    height: 25px;
    background-color: #dedede;
  }
}
.wsaTable {
  // margin: 8px 0px;
  padding: 12px;
  width: 100%;
  font-size: 12px;

  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-wsa3A {
    background-color: #c4def5;
    padding: 4px;
    font-size: 16px;
    background-color: #c8f0e0;
    color: #2cb17c;
  }
  tr {
    // border: 1px solid #a4abb3;
    // border-spacing: 0px;
  }
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 2px;
    text-align: center;
  }
  .grey-row-3A {
    background-color: #dedede;
  }
  .input-row-3A {
    background-color: #c4def5;
  }
}
</style>
